import { createUseStyles } from 'react-jss';

export default createUseStyles({
  topWidget: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gridTemplateRows: '25px 40px',
    rowGap: '10px',
    borderRadius: '11px',
    backgroundColor: '#ffffff',
    padding: '15px',
  },

  topWidgetTitle: {
    display: 'flex',
    alignItems: 'center',
    opacity: '0.88',
    color: '#102131',
    fontSize: '14px',
    fontWeight: '500',
    gridColumn: '1 / 2',
    gridRow: '1 / 2',
  },

  topWidgetValue: {
    color: '#102131',
    fontSize: '18px',
    fontWeight: '700',
    letterSpacing: '-0.1px',
    gridColumn: '1 / 2',
    gridRow: '2 / 3',
    alignSelf: 'center',
    marginLeft: '10px',
  },

  topWidgetIcon: {
    gridColumn: '2 / 3',
    gridRow: '1 / 3',
    alignSelf: 'center',
    justifySelf: 'center',
  },

  topWidgetContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
    '@media(max-width: 900px)': {
      gridTemplateColumns: '1fr',
      width: '100%',
      '& > div': {
        border: '1px solid #8986a1',
      }
    },
  },

  topPanelTitle: {
    display: 'flex',
    alignItems: 'center',
    color: '#102131',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '30px',
    paddingLeft: '20px',
    '@media(max-width: 900px)': {
      marginBottom: 0,
      paddingLeft: 0,
      justifyContent: 'center',
    }
  },
});
